import { isDev } from "@/utils/enviroment-detector"
import type { MenuItem } from "../menu.props"
import { ZordUtil } from "@/utils/Zord"
import { Device } from "@/utils/device"

interface BannerMenuProps {
    item: MenuItem
    device: number
    hostImagem: string
}

export function BannerMenu({ item, device, hostImagem }: Readonly<BannerMenuProps>) {
    if (!item?.banners?.length) return null

    function getMidiaUrl(path: string, nomeArquivo: string): string {
        return hostImagem + '/' + path + nomeArquivo
    }
    
    return (
        <div className="container-menu">
            {device == Device.DESKTOP && (
                <div className="banner-menu">
                    {item.banners.map((banner) => {
                        const width = banner.midia_opcoes?.original?.width ?? "initial"
                        const height = banner.midia_opcoes?.original?.height ?? "auto"

                        const imgTag = (
                            <img
                                className="lazyload"
                                src={isDev() ? getMidiaUrl(banner.path, banner.nome) : 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='}
                                data-src={getMidiaUrl(banner.path, banner.nome)}
                                alt={banner.midia_alt ?? ""}
                                title={banner.midia_title ?? ""}
                                width={width}
                                height={height}
                                style={{ height: "auto" }}
                            />
                        )

                        return banner.url ? <a href={ZordUtil.webPath(banner.url)}>{imgTag}</a> : imgTag
                    })}
                </div>
            )}
        </div>
    )
}